<template>
  <div class="row event">
    <div class="col">
      <a class="url" :href="evt.url" target="_blank">{{evt.url}}</a> | {{evt.event_id}}
      <h5>
        {{ evt.event_name }}
      </h5>
      <div v-if="editKeywords" class="input-group">
        <input ref="keywords" type="text" class="form-control" v-model="newKeywords" @keyup.enter="onSubmitKeywords" @keydown.esc="onCancelKeywords"/>
        <div class="input-group-append">
          <button type="button" class="btn btn-outline-dark" @click="onCancelKeywords">cancel</button>
          <button type="button" class="btn btn-outline-dark" @click="onSubmitKeywords">submit</button>
        </div>
      </div>
      <div class="keywords" v-else >
        <h5 v-if="keywords"><span class="text-muted">Keywords: </span> {{ keywords }}</h5>
        <button type="button" class="btn btn-outline-dark btn-sm" @click="onEditKeywords">{{ keywords ? 'edit' : 'add' }} keywords</button>
      </div>
      <div><b>{{evt.event_type}}</b> - {{ evt.start_time | moment('timezone', 'America/Chicago') }} - {{ evt.end_time | moment('timezone', 'America/Chicago') }}</div>
      <div>
        <template v-if="evt.venue_name || evt.venue_address || evt.venue_capacity">Venue: </template>
        <template v-if="evt.venue_name">{{evt.venue_name}}</template>
        <template v-if="evt.venue_address">, {{evt.venue_address}}</template>
        <template v-if="evt.venue_capacity">, Capacity: {{evt.venue_capacity}}</template>
      </div>
      <div class="row">
        <div class="col">
          <div><a @click.prevent.stop="showRawJson = !showRawJson" href="#">*</a></div>
          <pre v-if="showRawJson">{{ evt }}</pre>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { nextTick } from 'vue'

export default {
  name: 'SxswEvent',
  components: {},
  props: {
    evt: Object,
    keywords: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      showRawJson: false,
      newKeywords: '',
      editKeywords: false
    }
  },
  watch: {
    // keywords (val, oldVal) {
    //   console.log(' watch keywords', val, oldVal)
    //   if (val === oldVal) return
    //   if (val) this.newKeywords = val
    // }
  },
  computed: {
  },
  methods: {
    onEditKeywords () {
      this.editKeywords = true
      if (this.keywords) this.newKeywords = this.keywords
      this.$nextTick(() => {
        this.$refs.keywords.focus()
      })
    },
    onSubmitKeywords () {
      if (this.keywords !== this.newKeywords) {
        this.$socket.emit('/sxswscraper/keywords', { sxswId: this.evt.event_id, keywords: this.newKeywords })
      }
      this.editKeywords = false
    },
    onCancelKeywords () {
      this.editKeywords = false
      if (this.keywords) this.newKeywords = this.keywords
    }
  }

}
</script>
